import React, { FunctionComponent } from 'react';
import withStyles from 'react-jss';
import { FormattedDate, FormattedTime } from 'react-intl';

import { ClassProp } from 'helpers/types';
import { Theme } from 'config';

type Styles = ClassProp<ReturnType<typeof styles>>;

type Props = {
  label: string;
  date: string | Date;
  classes: Styles;
};

const styles = (theme: Theme) => ({
  spacer: {
    paddingRight: '.75rem !important',
    paddingBottom: '.5rem !important',
  },
  textLabel: {
    fontSize: '1.1rem',
    marginRight: '.5rem',
    fontWeight: 'bold',
  },
});

const DisplayTimestamp: FunctionComponent<Props> = ({
  label,
  date,
  classes,
}) => (
  <span className={classes.spacer}>
    <span className={classes.textLabel}>{label}</span>
    {date ? (
      <>
        <FormattedDate
          value={date}
          year="numeric"
          month="short"
          day="2-digit"
        />
        &nbsp;
        <FormattedTime value={date} />
      </>
    ) : (
      <span>On Going</span>
    )}
  </span>
);

export default withStyles(styles)(DisplayTimestamp);
